import { EntityFilterRow } from 'components/eventView/filters/EntityFilterRow';
import { PageHeaderMini } from 'components/eventView/layout/PageHeaderMini';
import { EventViewMapPageContent } from 'components/eventView/pages/EVMapPageContent';
import { SearchInput } from 'elements/eventView/atomic/SearchInput';
import { motion } from 'framer-motion';
import { EVDetailPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVDetailPageMobile';
import { useContext } from 'react';
import { Route, Routes, useNavigate } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVMapPageMobile = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { eventData, eventPath } = ctxEventView;

    const navigate = useNavigate();

    const mapEntities = eventData.eventInfo.otherEntities?.filter((e) => e.isMapEntity);

    function isOneSearchableEntity() {
        return mapEntities.length === 1 && mapEntities[0].isMapEntity;
    }

    return (
        <S_EVMapPageMobile className={props.className}>
            <S_Container>
                <PageHeaderMini>
                    {!isOneSearchableEntity() && <>{Localization.INTERACTIVE_MAP}</>}
                    {isOneSearchableEntity() && (
                        <SearchInput
                            value={''}
                            placeholder={mapEntities[0]?.name}
                            onFocus={() => {
                                navigate(`/event/${eventPath}/${mapEntities[0]?.id}?focusSearch=1`);
                            }}
                        />
                    )}
                    {/* {ctxEventView.eventData.eventInfo.entity && (
                        <S_SearchInput
                            placeholder={Localization.SEARCH}
                            onFocus={() => {
                                navigate(`/event/${eventPath}/list?focusSearch=1`);
                            }}
                        />
                    )}
                    {!ctxEventView.eventData.eventInfo.entity && (
                        <>{Localization.INTERACTIVE_MAP}</>
                    )} */}
                </PageHeaderMini>
                {ctxEventView.categories?.length > 0 && (
                    <S_FilterRow entityId="map" isWide={false} />
                )}
                <S_EVMapPageContent />
                <Routes location={location} key={location.pathname}>
                    <Route path="/map/:detailId" element={<S_EVDetailPageMobile />} />
                </Routes>
            </S_Container>
        </S_EVMapPageMobile>
    );
};

const S_EVMapPageMobile = styled(motion.div)`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    left: 0;
`;

const S_Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
`;

const S_EVDetailPageMobile = styled(EVDetailPageMobile)`
    position: absolute;
    top: 0;
    background: #f1f2f4;
    z-index: 3;
`;

const S_EVMapPageContent = styled(EventViewMapPageContent)`
    width: 100%;
    position: relative;
    display: flex;
    align-items: stretch;
    flex: 1;
`;

const S_FilterRow = styled(EntityFilterRow)`
    position: relative;
    z-index: 2;
`;
